import { List } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoListItem } from '~/components/MyWorkspace/InfoListItem';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.AbsenceDto;
}

export const AbsenceInfo: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <List disablePadding={true} sx={sxStyles.listRoot}>
      <InfoListItem
        primaryText={t('startDate')}
        secondaryText={moment(listItem.startDate).format('L')}
        dataCy="start-date"
      />
      {listItem.endDate && (
        <InfoListItem
          primaryText={t('endDate')}
          secondaryText={moment(listItem.endDate).format('L')}
          dataCy="end-date"
        />
      )}
      <InfoListItem
        primaryText={t('type')}
        secondaryText={t(`type${listItem.type}`)}
        dataCy="type"
      />
      {listItem.days && (
        <InfoListItem
          primaryText={t('days')}
          secondaryText={listItem.days.toString()}
          dataCy="days"
        />
      )}
      {/*To add this field when we have BE, so it would be clear how to download on click.*/}
      {/*<InfoListItem*/}
      {/*  primaryText={t('attachment')}*/}
      {/*  secondaryText={listItem.attachment}*/}
      {/*/>*/}
    </List>
  );
};
